export default __webpack_public_path__ + "static/summer-at-block-287fd2477e59f09476d47dd99011c5d8.svg";